import { motion } from 'framer-motion';
import { MessageSquare, ExternalLink } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const GatewayPage = () => {
  return (
    <div className="min-h-screen bg-[#0B0B0D] flex flex-col">
      <SEO
        title="Subsurface Gateway | Talk to our Telegram Triage Bot"
        description="Talk to the Subsurface Gateway, our conversational intake assistant on Telegram, to scope a Trust and Risk engagement."
        path="/gateway"
      />
      <Navigation />

      <div className="flex-1 pt-32 pb-24 px-6">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-12"
          >
            <h1 className="text-5xl md:text-6xl font-bold font-display mb-6">
              Subsurface Gateway
            </h1>
            <p className="text-lg text-[#A0A0A0] leading-relaxed">
              Talk to our AI assistant on Telegram. Get immediate answers, run quick diagnostics, or schedule a review.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="glass-card p-12 rounded-lg text-center"
          >
            <MessageSquare className="w-16 h-16 text-[#FF6A00] mx-auto mb-6" />
            
            <h2 className="text-2xl font-display font-semibold mb-4">Chat with Subsurface Gateway</h2>
            <p className="text-[#A0A0A0] mb-8 leading-relaxed">
              Our Telegram bot provides human-tone adaptive conversation. It can help you understand trust gaps, route you to a scan, or connect you directly with our team.
            </p>
            
            <a
              href="https://t.me/SubsurfaceGatewayBot"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-[#FF6A00] text-white font-semibold rounded-md hover:bg-[#FF6A00]/90 transition-all duration-300 shadow-[0_0_20px_rgba(255,106,0,0.3)]"
            >
              Open Telegram Gateway
              <ExternalLink className="w-5 h-5" />
            </a>

            <p className="text-xs text-[#A0A0A0] mt-6">
              Don't have Telegram? <a href="https://telegram.org/" target="_blank" rel="noopener noreferrer" className="text-[#FF6A00] hover:text-[#FF6A00]/80">Download here</a>
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="mt-12 text-center"
          >
            <p className="text-sm text-[#A0A0A0] mb-4">Prefer a different route?</p>
            <div className="flex flex-wrap justify-center gap-4">
              <a href="/scan" className="text-sm text-[#FF6A00] hover:text-[#FF6A00]/80 transition-colors">
                Run Scan
              </a>
              <a href="/submit" className="text-sm text-[#FF6A00] hover:text-[#FF6A00]/80 transition-colors">
                Submit Details
              </a>
              <a href="/" className="text-sm text-[#FF6A00] hover:text-[#FF6A00]/80 transition-colors">
                Return Home
              </a>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GatewayPage;
